// Based on https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
export const KEY = {
    ENTER: 'Enter',
    ESC: 'Escape',
};
